<template>
  <HeaderContent title="Room Category" />
  <ActionContent
    ctaText="Add Room Category"
    @action="showModal"
    :filterDate="false"
    :filterModal="false"
    @search-query="searchData"
  />
  <RoomCategoryStatistics title="Room Category Statistics" :data="statistics" />
  <RoomCategoryForm
    :modal="modal"
    :roomCategoryData="roomCategory"
    @update:modal="updateModal"
    @addOrUpdate="getAll"
  />
  <RoomCategoryConfirm
    title="Confirmation"
    :uuid="roomCategoryUuid"
    v-model="modalConfirm"
    @confirmed="deleteData(roomCategoryUuid)"
  >
    <template #text>Are you sure to delete this data ?</template>
  </RoomCategoryConfirm>
  <RoomCategoryDataTable
    :data="roomCategories"
    :header="headers"
    :currentPage="currentPage"
    :custom-actions="customActions"
  />
</template>

<script>
import HeaderContent from "@/components/HeaderContent.vue";
import ActionContent from "@/components/ActionContent.vue";
import RoomCategoryForm from "./RoomCategoryForm.vue";
import RoomCategoryDataTable from "@/components/DataTable.vue";
import RoomCategoryStatistics from "@/components/StatisticData.vue";
import RoomCategoryConfirm from "@/components/ModalDialog.vue";
import iconDormRoom from "../../../public/icons/dorm-room.svg";
import { ref, inject, onMounted } from "vue";

export default {
  components: {
    HeaderContent,
    ActionContent,
    RoomCategoryForm,
    RoomCategoryDataTable,
    RoomCategoryStatistics,
    RoomCategoryConfirm,
  },
  setup() {
    const repositories = inject("repositories");
    const roomCategoryRepository = repositories
      ? repositories.roomCategory
      : null;
    const modal = ref(false);
    const modalConfirm = ref(false);
    const roomCategoryUuid = ref(null);
    const roomCategory = ref({});
    const roomCategories = ref([]);

    const headers = ref([
      {
        key: "no",
        label: "No",
        thClass: "text-left",
        tdClass: "text-left",
        sortable: true,
      },
      {
        key: "room_category",
        label: "Room Category",
        thClass: "text-center",
        tdClass: "text-center",
        sortable: true,
      },
      {
        key: "low_season_price",
        label: "Low Season Price",
        thClass: "text-center",
        tdClass: "text-center",
        sortable: true,
      },
      {
        key: "high_season_price",
        label: "High Season Price",
        thClass: "text-center",
        tdClass: "text-center",
        sortable: true,
      },
      {
        key: "description",
        label: "Description",
        thClass: "text-left",
        tdClass: "text-left",
        sortable: true,
      },
      {
        key: "action",
        label: "Actions",
      },
    ]);

    const customActions = ref([
      {
        label: "Edit",
        variant: "success",
        icon: "fas fa-edit",
        action: (item) => {
          getById(item.uuid);
        },
      },
      {
        label: "Delete",
        variant: "danger",
        icon: "fas fa-trash",
        action: (item) => {
          showConfirmModal(item.uuid);
        },
      },
    ]);

    const statistics = ref([]);

    const getAll = async () => {
      await roomCategoryRepository
        .getAll()
        .then((res) => {
          const mapRoomCategories = res.data.data.map((i) => ({
            ...i,
            room_category: i.name,
          }));
          roomCategories.value = mapRoomCategories;
          statistics.value = [
            {
              label: "Total",
              key: "Room Category",
              value: res.data.data.length,
              color: "primary",
              icon: iconDormRoom,
            },
          ];
        })
        .catch((err) => {
          console.error(err);
        });
    };

    const getById = async (uuid) => {
      await roomCategoryRepository
        .getById(uuid)
        .then((res) => {
          roomCategory.value = res.data.data;
          modal.value = true;
        })
        .catch((err) => {
          console.error(err);
        });
    };

    const updateModal = (newValue) => {
      modal.value = newValue;
      roomCategory.value = {};
    };

    const showModal = () => {
      modal.value = true;
    };

    const showConfirmModal = (uuid) => {
      modalConfirm.value = true;
      roomCategoryUuid.value = uuid;
    };

    const deleteData = async (uuid) => {
      console.log(uuid);
      await roomCategoryRepository
        .delete(roomCategoryUuid.value)
        .then(() => {
          modalConfirm.value = false;
          getAll();
        })
        .catch((err) => {
          console.error(err);
        });
    };

    const searchData = async (keyword) => {
      await roomCategoryRepository
        .search(keyword)
        .then((res) => {
          roomCategories.value = res.data.data;
        })
        .catch((err) => {
          console.error(err);
        });
    };

    onMounted(() => {
      getAll();
    });

    return {
      modal,
      modalConfirm,
      roomCategoryUuid,
      roomCategory,
      roomCategories,
      headers,
      customActions,
      statistics,
      updateModal,
      showModal,
      showConfirmModal,
      deleteData,
      getAll,
      getById,
      searchData,
    };
  },
};
</script>
